<template>
    <div class="documentary_page">
      <page :page='news' :router_name='router_name'></page>
      <div v-show="news.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
          <img src="../../assets/loading.gif">
      </div>
      <moreButton button_text="返回列表" button_href="../documentary"></moreButton>
    </div>
</template>
<script>
import MoreButton from '@/components/index/MoreButton'
import page from '@/components/list/page'
export default {
    components: {
    'moreButton': MoreButton,
    'page': page,
  },
    data () {
    return {
      news: [],
      router_name:"../documentary",
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
    created(){
      var newsid = this.$route.params.id;
      // var newsbox = [];
      var vm = this
      var news_api = vm.API + 'api/tlweb/documentary?online=1&kind=4'
    this.axios.get(news_api)
      .then(function (response) {
        // newsbox = response.data.data.data.reverse()
        // console.log(newsbox.id);
        vm.news = response.data.data.data.reverse().find(function(item){
          // console.log(item.id);
          item.create_at=item.create_at.substr(0,10)
           return item.id==newsid;  
        });
        // console.log(vm.news);
        // console.log(vm.news[0].id);
        // for(var search=0;search<newsbox.length;search++){
        //     if(newsid==newsbox[search].id){
        //       vm.news = newsbox[search]
        //     }
        // }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  mounted(){
      // var table = document.getElementsByTagName('table')
      // console.log(table.style.width)
        // table="";
  }
    
}
</script>

<style>
.documentary_page iframe{
  /* position: absolute;
    top: 0;
    left: 0; */
    width: 100%;
    height: 60vh;
}
/* .documentary_page #page_content{
  position: relative;
    padding-bottom: 65.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
} */
@media (max-width: 768px){
  .documentary_page iframe{
      height: 40vh;
  }
}
</style>


